import { render, staticRenderFns } from "./NewSummary.vue?vue&type=template&id=5760803b&"
import script from "./NewSummary.vue?vue&type=script&lang=js&"
export * from "./NewSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports